export class Alert {

  type: AlertType;

  message: string;

  translateParams: Record<string, any>;

  constructor(type: AlertType, message: string, translateParams = {}) {
    this.type = type;
    this.message = message;
    this.translateParams = Object.assign({br: '<br>'}, translateParams);
  }
}

export enum AlertType {
  Primary = 'primary',
  Danger = 'danger',
  Warning = 'warning'
  // others if needed
}
